import React from "react";

import ModalTrigger, {ModalTriggerProps} from "../Modal/ModalTrigger";
import ConfirmationModal, {ConfirmationModalProps} from "./ConfirmationModal";

type ConfirmationModalTriggerProps = Omit<
  ModalTriggerProps,
  "modalComponent" | "modalClassName"
> &
  Omit<ConfirmationModalProps, "onClose"> & {
    children: JSX.Element;
  };

export default function ConfirmationModalTrigger(
  props: ConfirmationModalTriggerProps
): JSX.Element {
  return <ModalTrigger {...props} modalComponent={ConfirmationModal} />;
}
